export default __webpack_public_path__ + "static/media/1871.dc14e02c.png";